import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit, OnDestroy {
  rol: string | null = null;
  goAdminFlag: boolean = false;
  newProyectFlag: boolean = false;
  proyectsSetDataFlag: boolean = false;
  newSaleSellerFlag: boolean = false;
  setDataSellerFlag: boolean = false;
  addDividendsFlag: boolean = false;
  setRolFlag: boolean = false;
  documentationGeneralFlag: boolean = false;
  uriYoutubeFlag: boolean = false;
  editTutorialsFlag: boolean = false;
  editReferralTutorialsFlag: boolean = false;
  buyThroughCompanyFlag: boolean = false;
  buyBatchThroughCompanyFlag: boolean = false;
  setWhitelistFlag: boolean = false;
  forcedTransferFlag: boolean = false;
  fundsTransferFlag: boolean = false;
  setPauseFlag: boolean = false;
  setKycFlag: boolean = false;
  revertPaymentsFlag: boolean = false;
  infoDividendsFlag: boolean = false;
  buyWithoutPayFlag: boolean = false;
  hideProyectFlag: boolean = false;
  docsLegalFlag: boolean = false;
  adminWalletFlag: boolean = false;
  withdrawalRequestsFlag: boolean = false;
  fiscalDocumentationFlag: boolean = false;
  failedPaymentsManagementFlag: boolean = false;
  goFailedPaymentsManagement() {
    this.goAdminFlag = true;
    this.failedPaymentsManagementFlag = true;
  }
  manageBonusesFlag: boolean = false;
  balanceResumeFlag: boolean = false;
  reservesFlag: boolean = false;
  setCreditCardFeeFlag: boolean = false;
  // dropdown options
  showProyectosOptions: boolean = false;
  showGestionDividendos: boolean = false;
  showInversiones: boolean = false;
  showKyc: boolean = false;
  showAdminWallet: boolean = false;
  showDocumentacion: boolean = false;
  showRedesSocciales: boolean = false;
  showOtrasgestiones: boolean = false;
  showGestionRetiros: boolean = false;

  // ✅ KISS Pattern: Simple subscription cleanup
  private destroy$ = new Subject<void>();

  toggleProyectosOptions() {
    this.showProyectosOptions = !this.showProyectosOptions;
    this.showGestionDividendos = false;
    this.showInversiones = false;
    this.showKyc = false;
    this.showAdminWallet = false;
    this.showDocumentacion = false;
    this.showRedesSocciales = false;
    this.showOtrasgestiones = false;
  }

  toggleGestionDividendos() {
    this.showGestionDividendos = !this.showGestionDividendos;
    this.showProyectosOptions = false
    this.showInversiones = false
    this.showKyc = false
    this.showAdminWallet = false
    this.showDocumentacion = false
    this.showRedesSocciales = false
    this.showOtrasgestiones = false
  }
  toggleInversiones() {
    this.showInversiones = !this.showInversiones;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showKyc = false
    this.showAdminWallet = false
    this.showDocumentacion = false
    this.showRedesSocciales = false
    this.showOtrasgestiones = false
  }

  toggleKyc() {
    this.showKyc = !this.showKyc;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showInversiones = false
    this.showAdminWallet = false
    this.showDocumentacion = false
    this.showRedesSocciales = false
    this.showOtrasgestiones = false
  }

  toggleAdminWallet() {
    this.showAdminWallet = !this.showAdminWallet;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showInversiones = false
    this.showKyc = false
    this.showDocumentacion = false
    this.showRedesSocciales = false
    this.showOtrasgestiones = false
  }

  toggleDocumentacion() {
    this.showDocumentacion = !this.showDocumentacion;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showInversiones = false
    this.showKyc = false
    this.showAdminWallet = false
    this.showRedesSocciales = false
    this.showOtrasgestiones = false
  }

  toggleRedesSocciales() {
    this.showRedesSocciales = !this.showRedesSocciales;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showInversiones = false
    this.showKyc = false
    this.showAdminWallet = false
    this.showDocumentacion = false
    this.showOtrasgestiones = false
  }

  toggleOtrasgestiones() {
    this.showOtrasgestiones = !this.showOtrasgestiones;
    this.showProyectosOptions = false
    this.showGestionDividendos = false
    this.showInversiones = false
    this.showKyc = false
    this.showAdminWallet = false
    this.showDocumentacion = false
    this.showRedesSocciales = false
    this.showGestionRetiros = false
    this.fundsTransferFlag = false;
    this.manageBonusesFlag = false;
    this.balanceResumeFlag = false;
  }

  toggleGestionRetiros() {
    this.showGestionRetiros = !this.showGestionRetiros;
    this.showProyectosOptions = false;
    this.showGestionDividendos = false;
    this.showInversiones = false;
    this.showKyc = false;
    this.showAdminWallet = false;
    this.showDocumentacion = false;
    this.showRedesSocciales = false;
    this.showOtrasgestiones = false;
  }

  constructor(
    private afs: AngularFirestore,
    private authSrv: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkAdminAccess();
  }

  /**
   * Comprueba el rol contra Firestore antes de dar por bueno el acceso.
   *
   * Estar autenticado no implica ser administrador: si solo se comprueba la
   * sesion, cualquier usuario que alcance esta pantalla la veria renderizada.
   * La verificacion se repite aqui ademas de en el AdminGuard de la ruta, para
   * que el componente no dependa de que el guard se haya ejecutado.
   */
  checkAdminAccess() {
    this.authSrv.userAuth
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user: any) => {
      if (!user?.uid) {
        this.rol = null;
        this.router.navigate(['/']);
        return;
      }

      try {
        const adminDoc = await this.afs
          .collection('administrators')
          .doc(user.uid)
          .get()
          .toPromise();

        if (adminDoc?.exists && (adminDoc.data() as any)?.admin === true) {
          this.rol = 'admin';
          return;
        }
      } catch (error) {
        console.error('[Admin] No se pudo verificar el rol de administrador');
      }

      // Fail-closed: sin verificacion positiva no se muestra el panel.
      this.rol = null;
      this.router.navigate(['/oportunidades']);
    });
  }

  goSetRol() {
    this.goAdminFlag = true;
    this.setRolFlag = true;
  }

  goNewProyect() {
    this.goAdminFlag = true;
    this.newProyectFlag = true;
  }

  goProyectsSetData() {
    this.goAdminFlag = true;
    this.proyectsSetDataFlag = true;
  }

  goNewSaleSeller() {
    this.goAdminFlag = true;
    this.newSaleSellerFlag = true;
  }

  goSetDataSeller() {
    this.goAdminFlag = true;
    this.setDataSellerFlag = true;
  }

  goAddDividends() {
    this.goAdminFlag = true;
    this.addDividendsFlag = true;
  }

  goDocumentation() {
    this.goAdminFlag = true;
    this.documentationGeneralFlag = true;
  }

  goUriYoutube() {
    this.goAdminFlag = true;
    this.uriYoutubeFlag = true;
    this.editTutorialsFlag = false;
  }

  goEditTutorials() {
    this.goAdminFlag = true;
    this.editTutorialsFlag = true;
  }

  goEditReferralTutorials() {
    this.goAdminFlag = true;
    this.editReferralTutorialsFlag = true;
  }

  goBuyThroughCompamy() {
    this.goAdminFlag = true;
    this.buyThroughCompanyFlag = true;
  }

  goBuyBatchThroughCompany() {
    this.goAdminFlag = true;
    this.buyBatchThroughCompanyFlag = true;
  }

  goSetWhitelist() {
    this.goAdminFlag = true;
    this.setWhitelistFlag = true;
  }

  goForcedTransfer() {
    this.goAdminFlag = true;
    this.forcedTransferFlag = true;
  }

  goBatchTransfer() {
    this.goAdminFlag = true;
    this.fundsTransferFlag = true;
  }

  goSetPause() {
    this.goAdminFlag = true;
    this.setPauseFlag = true;
  }

  goSetKyc() {
    this.goAdminFlag = true;
    this.setKycFlag = true;
  }

  goRevertPayments() {
    this.goAdminFlag = true;
    this.revertPaymentsFlag = true;
  }

  goInfoDividends() {
    this.goAdminFlag = true;
    this.infoDividendsFlag = true;
  }

  goBuyWithoutPay() {
    this.goAdminFlag = true;
    this.buyWithoutPayFlag = true;
  }

  goHideProyect() {
    this.goAdminFlag = true;
    this.hideProyectFlag = true;
  }

  goDocsLegal() {
    this.goAdminFlag = true;
    this.docsLegalFlag = true;
  }

  goAdminWallet() {
    this.goAdminFlag = true;
    this.adminWalletFlag = true;
  }

  goWithdrawalRequests() {
    this.goAdminFlag = true;
    this.withdrawalRequestsFlag = true;
  }

  goFiscalDocumentation() {
    this.goAdminFlag = true;
    this.fiscalDocumentationFlag = true;
  }

  goManageBonuses() {
    this.goAdminFlag = true;
    this.manageBonusesFlag = true;
  }

  goBalanceResume() {
    this.goAdminFlag = true;
    this.balanceResumeFlag = true;
  }

  goReserves() {
    this.goAdminFlag = true;
    this.reservesFlag = true;
  }

  goSetCreditCardFee() {
    this.goAdminFlag = true;
    this.setCreditCardFeeFlag = true;
  }

  goAdmin() {
    this.goAdminFlag = false;
    this.newProyectFlag = false;
    this.proyectsSetDataFlag = false;
    this.newSaleSellerFlag = false;
    this.setDataSellerFlag = false;
    this.addDividendsFlag = false;
    this.setRolFlag = false;
    this.documentationGeneralFlag = false;
    this.uriYoutubeFlag = false;
    this.editTutorialsFlag = false;
    this.editReferralTutorialsFlag = false;
    this.buyThroughCompanyFlag = false;
    this.buyBatchThroughCompanyFlag = false;
    this.setWhitelistFlag = false;
    this.forcedTransferFlag = false;
    this.fundsTransferFlag = false;
    this.setPauseFlag = false;
    this.setKycFlag = false;
    this.revertPaymentsFlag = false;
    this.infoDividendsFlag = false;
    this.buyWithoutPayFlag = false;
    this.hideProyectFlag = false;
    this.docsLegalFlag = false;
    this.adminWalletFlag = false;
    this.withdrawalRequestsFlag = false;
    this.fiscalDocumentationFlag = false;
    this.manageBonusesFlag = false;
    this.failedPaymentsManagementFlag = false;
    this.balanceResumeFlag = false;
    this.reservesFlag = false;
    this.setCreditCardFeeFlag = false;
  }

  // ✅ KISS Pattern: Simple cleanup
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
